module.exports = __webpack_public_path__ + "img/stock3.b6690f1a.png";